import { Injectable } from "@angular/core";
import { InspectionTypeRepository } from "../repositories/inspection.type.repository";
import { InspectionType } from "../types/Inspection/InspectionType";
import { LogService } from "./log.service";
import { BaseService } from "./base.service";
import { FollowUpConfigs } from "../types/Inspection/FollowUpConfigs";
import { AdvancedConfigs } from "../types/Inspection/AdvancedConfigs";
import { TamOptions } from "../types/Inspection/TamOptions";
import { handleTruthyValues } from "../../utils";
import { applyViolationEntryOverride } from "../utils/violation-entry-overrides";

@Injectable({
  providedIn: "root",
})
export class InspectionTypeService extends BaseService {
  constructor(
    private inspectionTypeRepo: InspectionTypeRepository,
    logService: LogService,
  ) {
    super(logService, "InspectionTypeService");
  }

  public getById(inspectionTypeID: string): InspectionType {
    return this.inspectionTypeRepo.getById(inspectionTypeID);
  }

  public getGeneralFormFields(inspectionTypeID: string): any[] {
    const inspectionType = this.getById(inspectionTypeID);
    return inspectionType?.generalForm?.form || [];
  }

  public getViolationFormFields(inspectionTypeID: string): any[] {
    const inspectionType = this.getById(inspectionTypeID);
    return inspectionType?.vioInput?.form || [];
  }

  public getViolationFormFieldsForItem(
    inspectionTypeID: string,
    violationItemID?: string,
  ): any[] {
    const inspectionType = this.getById(inspectionTypeID);
    const base = inspectionType?.vioInput?.form || [];
    if (!violationItemID) {
      return base;
    }
    const overrideMap = inspectionType?.vioInput?.itemOverrides || {};
    const override = (overrideMap as any)?.[violationItemID];
    return applyViolationEntryOverride(base, override);
  }

  public getAdvancedConfigs(inspectionTypeID: string): AdvancedConfigs {
    const inspectionType = this.getById(inspectionTypeID);
    return inspectionType?.advancedConfigs;
  }

  public getFollowUpConfigs(inspectionTypeID: string): FollowUpConfigs {
    const advancedConfigs = this.getAdvancedConfigs(inspectionTypeID);
    if (advancedConfigs?.followupConfigs) {
      return Object.fromEntries(
        Object.entries(advancedConfigs.followupConfigs).map(
          ([key, value]: any) => {
            return [key, handleTruthyValues(value)];
          },
        ),
      );
    }
    return {
      copyOnlyViolations: false,
      copyCOSViolations: false,
      prefillObservations: false,
      onlyShowPrior: false,
    };
  }

  public getTamOptions(inspectionTypeID: string): TamOptions {
    const advancedConfigs = this.getAdvancedConfigs(inspectionTypeID);
    return advancedConfigs?.tamConfigs || { activate: "", require: "" };
  }
}
